import React, { useEffect, useState } from 'react';
import InputForm from '../../InputT';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SweetAlert from 'sweetalert2';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import DataType from '../../../Types/DataTablePiclist';
import { Box } from '@mui/material';
import SearchInput from '../../SearchInput';
import SearchModal from '../../SearchModal';
import { useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import SelectOption from '../../SelectOption';


const Tab1 = (props: { etatG?: boolean, form?: any, Function?: Function }) => {

  const datas: DataType[] = [];
  const [Numcli, SetNumcli] = useState();
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


  //vérification de la date de naissance qui doit etre supérieur à la date actuel
  const handleChangeClient = () => {

    props.form.setFieldValue("NUMCPT", '')
    props.form.setFieldValue("lib_NUMCPT", '')

    let Numcli = props.form.getFieldValue("NUMCLI");
    SetNumcli(Numcli);

  };


  //Initialisation des parametres de recherche
  let searchCategocpt: ParamsPicklist = { CodeAgence: "CATEGOCPT", Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
  let searchNumCompte: ParamsPicklist = { CodeAgence: Numcli ? Numcli : "JH", Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "NUMCLI", Choix: 22 }
  let searchTypeCompte: ParamsPicklist = { CodeAgence: 'TYPCPT', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
  let searchDevise: ParamsPicklist = { CodeAgence: "DEVISE", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
  let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "", Choix: 22 }
  let searchClient: ParamsPicklist = { CodeAgence: user.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE', Choix: 22 }
  let searchComptegroupe: ParamsPicklist = { CodeAgence: "", Table: "", Colonne1: "idplan", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
  let searchSenseSolde: ParamsPicklist = { CodeAgence: "SENSEC", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
  let searchPlanComptable: ParamsPicklist = { CodeAgence: '', Table: "plancp", Colonne1: "idplan", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
  let searchGestionnaire: ParamsPicklist = { CodeAgence: 'GESTIONNAIRE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }


  //information du comptable
  let informationComptable = {
    SearchNumCompte: {
      Titre: "Recherche Compte",
      label: "Numéro de compte",
      name: "NUMCPT", params: searchNumCompte
    },
    SearTypeCompte: {
      Titre: "Recherche Type Compte",
      label: "Type de compte",
      name: "TYPCPT", params: searchTypeCompte
    },
    SearchCompteFus: {
      Titre: "Recherche Compte de fusion",
      label: "Compte de fusion",
      name: "CPTFUS", params: searchNumCompte
    },
    SearchNumcli:
    {
      Titre: "Recherche Numéro Client",
      label: "Numéro client",
      name: "NUMCLI", params: searchClient
      //suspend  
    },
    SearchPlancp:
    {
      Titre: "Recherche Plan Comptable",
      label: "Plan comptable",
      name: "IDPLAN", params: searchPlanComptable
    },
    SearchCategoCpt: {
      Titre: "Recherche Catégorie Compte",
      label: "Catégorie compte",
      name: "categocpt", params: searchCategocpt
    },
    InputNomcpt: {
      label: "Intitulé du compte",
      name: "NOMCPT"
    },
    SearchEtat: {
      Titre: "Recherche Etat",
      label: "Status compte",
      name: "CDPAYS", params: searchAgence
    },
    InputNomcpt2: {
      label: "Intitulé du compte",
      name: "NOM du Compte"
    },
    InputNomcli: {
      label: "Nom du client",
      name: "Client"
    },
    SearchGestionnaire: {
      Titre: "Recherche Gestionnaire",
      label: "Gestionnaire",
      name: "CDGESTCLI", params: searchGestionnaire
    },
    InputNbreSms: {
      label: "Nombre de SMS",
      name: "nbrSMS"
      //suspend
    },
    InputDateModif: {
      label: "Date modification",
      name: "DATDMC"
      //suspend
    },
    InputNvDeb: {
      label: "Niveau débit",
      name: "NIVDEB"
    },
    InputNvCre: {
      label: "Niveau crédit",
      name: "NIVCRE"
    },
    InputNvConsul: {
      label: "Niveau consultation",
      name: "NIVCON"
    },
    InputNbreMvbCre: {
      label: "Nombre de Mvt Crédit",
      name: "NBMVCR"
    },
    InputNbreMvbDeb: {
      label: "Nombre de Mvt Débit",
      name: "NBMVDB"
    },
    InputMessageCtrlCpt:
    {
      label: "Message de controle compte",
      name: "MESSCON"
    }
  }


  return (

    <div className='tabItem' >
      <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
        <Box style={{ display: 'flex' }}   >
          <Box fontStyle="inherit" className='border-left'>
            <SearchInput form={props.form} handleFunction={handleChangeClient} width={7} Titre={informationComptable.SearchNumcli.Titre} label={informationComptable.SearchNumcli.label} name={informationComptable.SearchNumcli.name} Parametre={informationComptable.SearchNumcli.params} />
            <SearchModal form={props.form} width={7} Titre={informationComptable.SearTypeCompte.Titre} label={informationComptable.SearTypeCompte.label} name={informationComptable.SearTypeCompte.name} Parametre={informationComptable.SearTypeCompte.params} />
            <SearchModal notRequired form={props.form} width={7} Titre={informationComptable.SearchCompteFus.Titre} label={informationComptable.SearchCompteFus.label} name={informationComptable.SearchCompteFus.name} Parametre={informationComptable.SearchCompteFus.params} />
            <SearchModal form={props.form} width={7} Titre={informationComptable.SearchPlancp.Titre} label={informationComptable.SearchPlancp.label} name={informationComptable.SearchPlancp.name} Parametre={informationComptable.SearchPlancp.params} />
            <SearchModal width={7} notRequired form={props.form} Titre={"Recherche Sence Solde"} label={"Sens du solde"} name={"senSsolde"} Parametre={searchSenseSolde} />
          </Box>

          <Box fontStyle="inherit" className='border-left'>
            <SelectOption disabled={false} Size={'middle'} label={informationComptable.SearchNumCompte.label} name={informationComptable.SearchNumCompte.name} Parametre={informationComptable.SearchNumCompte.params}  />
            {/* <SearchInput width={7} notRequired form={props.form} Titre={informationComptable.SearchNumCompte.Titre} label={informationComptable.SearchNumCompte.label} name={informationComptable.SearchNumCompte.name} Parametre={informationComptable.SearchNumCompte.params} /> */}
            {/* <InputForm width={9} label={informationComptable.InputNomcpt.label} name={informationComptable.InputNomcpt.name} type='text' /> */}
            <SearchModal form={props.form} width={7} Titre={informationComptable.SearchEtat.Titre} label={informationComptable.SearchEtat.label} name={informationComptable.SearchEtat.name} Parametre={informationComptable.SearchEtat.params} />
            {/* <InputForm width={9} label={informationComptable.InputNomcpt2.label} name={informationComptable.InputNomcpt2.name} type='text' />
            <InputForm width={9} label={informationComptable.InputNomcli.label} name={informationComptable.InputNomcli.name} type='text' /> */}
            <SearchModal form={props.form} width={7} Titre={informationComptable.SearchGestionnaire.Titre} label={informationComptable.SearchGestionnaire.label} name={informationComptable.SearchGestionnaire.name} Parametre={informationComptable.SearchGestionnaire.params} />
            <SearchModal form={props.form} width={7} Titre={informationComptable.SearchCategoCpt.Titre} label={informationComptable.SearchCategoCpt.label} name={informationComptable.SearchCategoCpt.name} Parametre={informationComptable.SearchCategoCpt.params} />
            <Box display={'inline-flex'}>
              <InputForm width={15} label={informationComptable.InputNbreSms.label} name={informationComptable.InputNbreSms.name} type='text' />
              <InputForm notRequired disabled label={informationComptable.InputDateModif.label} name={informationComptable.InputDateModif.name} type='date' />
            </Box>
          </Box>
        </Box>

        <Box display={'inline-flex'}>
          <InputForm width={17} label={informationComptable.InputNvDeb.label} name={informationComptable.InputNvDeb.name} type='text' />
          <InputForm width={17} label={informationComptable.InputNvCre.label} name={informationComptable.InputNvCre.name} type='text' />
          <InputForm width={17} label={informationComptable.InputNvConsul.label} name={informationComptable.InputNvConsul.name} type='text' />
          <InputForm width={17} label={informationComptable.InputNbreMvbCre.label} name={informationComptable.InputNbreMvbCre.name} type='text' />
          <InputForm width={17} label={informationComptable.InputNbreMvbDeb.label} name={informationComptable.InputNbreMvbDeb.name} type='text' />
        </Box>
        <InputForm notRequired width={5} label={informationComptable.InputMessageCtrlCpt.label} name={informationComptable.InputMessageCtrlCpt.name} type='TextArea' />
      </Box>

    </div>
  );
}

export default Tab1;